module.exports = __webpack_public_path__ + "apple-touch-icon-72x72.png?1514359ccad5f4ff8bae4fa2c6776873";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-touch-icon-72x72.png
// module id = 144
// module chunks = 0